const httpTools = (function () {
    return {
        envMemberUrls: function () {
            if (window.location.hostname === "membership.unicity.com") {
                return "https://member-calls2.unicity.com";
            } else {
                return "https://member-calls2-dev.unicity.com";
            }
        },
        envUrls: function (liveOverride = false) {
            //build out domain checking to return correct apiUrl
            if (window.location.hostname === "membership.unicity.com" || liveOverride) {
                return "https://hydra.unicity.net/v5a";
            } else {
                return "https://hydraqa.unicity.net/v5a-test";
            }
        },
        subApiUrl: function () {
            var liveOverride = false;
            //build out domain checking to return correct apiUrl
            if (window.location.hostname === "membership.unicity.com" || liveOverride) {
                return "https://hydra.unicity.net/v5a";
            } else {
                return "https://hydraqa.unicity.net/v5a-test";
            }
        },
        envFlags: function () {
            var liveOverride = false;
            //build out domain checking to return correct apiUrl
            if (window.location.hostname === "membership.unicity.com" || liveOverride) {
                return "v5a";
            } else {
                return "v5a-test";
            }
        },
        self: function () {
            var localhost = /localhost/;
            var unicityqa = /unicityqa.com/;
            //var production = /shop.unicity.com/;
            if (window.location.hostname.match(localhost)) {
                return "http://localhost";
            } else if (window.location.hostname.match(unicityqa)) {
                return "https://dev-enroll.unicityqa.com/master";
            } else {
                return "http://membership.unicity.com";
            }
        },
        getTranslationUrl: function () {
            //build out domain checking to return correct apiUrl
            if (window.location.hostname.match("membership.unicity.com")) {
                return "https://cdn.unicity.com/translations/membership";
            } else {
                return "https://cdn.unicity.com/translations/qa/membership";
            }
        },
        getFeatureFlagsUrl: function () {
            //build out domain checking to return correct apiUrl
            if (window.location.hostname.match("membership.unicity.com")) {
                return "https://unicityparlance.firebaseio.com/feature_flags/live/enrollment.json";
            } else {
                return "https://unicityparlance.firebaseio.com/feature_flags/dev/enrollment.json";
            }
        },
        getHeader: function () {
            return {
                "Content-Type": "application/json",
                "x-application": "membership"
            };
        }
    };
})();

export default httpTools;



// WEBPACK FOOTER //
// ./src/services/http/httpTools.js